import * as React from 'react'

import { Chevron } from '@factorialco/deprecated-design-system'
import classNames from 'classnames'
import _ from 'lodash'

import './index.styles.css'

interface Props {
  close?: string
  disabled?: boolean
  more?: string
  overflowVisible?: boolean
  overflowLimit?: number
  noBottomRadius?: boolean
  noTopRadius?: boolean
}

// TODO: Consider moving it to the design system
export const BoxList: React.FC<React.PropsWithChildren<Props>> = ({
  close,
  disabled,
  more,
  overflowVisible,
  overflowLimit,
  noBottomRadius,
  noTopRadius,
  children,
}) => {
  const [isOpen, setIsOpen] = React.useState(false)

  const onClickToggle = React.useCallback(() => {
    setIsOpen((prevState) => !prevState)
  }, [])

  const renderCollapse = React.useCallback(
    (elements: number) => {
      if (!overflowLimit) return null

      if (!close && !more) throw new Error('close or more props are required')

      return (
        <div className="BoxList_toggle" onClick={onClickToggle} role="button">
          <span className="BoxList_toggleText">{isOpen ? close : more}</span>
          <Chevron direction={isOpen ? 'up' : 'down'} type="terciary" />
        </div>
      )
    },
    [close, more, overflowLimit, isOpen, onClickToggle]
  )

  const renderItem = React.useCallback((element: React.ReactElement<any>, i: number) => {
    return (
      <li className="BoxList_item" key={i}>
        {element}
      </li>
    )
  }, [])

  if (!children) return null

  const elements = React.Children.map(
    _.compact(React.Children.toArray(children)) as any,
    renderItem
  )

  const className = classNames('BoxList_list', {
    disabled,
    BoxList_overflowVisible: overflowVisible,
    BoxList_noBottomRadius: noBottomRadius,
    BoxList_noTopRadius: noTopRadius,
  })

  if (overflowLimit) {
    const isOverflow = elements.length > overflowLimit

    return (
      <ul className={className}>
        {elements.slice(0, isOpen ? elements.length : overflowLimit)}
        {isOverflow && renderCollapse(elements.length)}
      </ul>
    )
  }

  return <ul className={className}>{elements}</ul>
}

export default BoxList
